export const LOADING_TEMPLATES = 'LOADING_TEMPLATES_IN_TEMPLATE_LIST';
export const LOADING_TEMPLATES_FOR_WIZARD = 'LOADING_TEMPLATES_FOR_TEMPLATE_GROUP_WIZARD';
export const TEMPLATES_LOADED = 'TEMPLATES_LOADED_IN_TEMPLATE_LIST';
export const TEMPLATES_LOADED_FOR_WIZARD = 'TEMPLATES_LOADED_FOR_TEMPLATE_GROUP_WIZARD';
export const LOADING_DRAFTS = 'LOADING_DRAFTS_IN_TEMPLATE_LIST';
export const DRAFTS_LOADED = 'DRAFTS_LOADED_IN_TEMPLATE_LIST';
export const UPDATE_PROPS = '[template-list]UPDATE_PROPS_IN_TEMPLATE_LIST';
export const DRAFT_CREATED = 'DRAFT_CREATED_IN_TEMPLATE_LIST';
export const TEMPLATE_DELETED = 'TEMPLATE_DELETED_IN_TEMPLATE_LIST';
export const DRAFT_DELETED = 'DRAFT_DELETED_IN_TEMPLATE_LIST';
export const UPDATE_TEMPLATE_PROPS = 'UPDATE_TEMPLATE_PROPS_IN_TEMPLATE_LIST';
export const UPDATE_DRAFT_PROPS = 'UPDATE_DRAFT_PROPS_IN_TEMPLATE_LIST';
export const STARTING_DRAFT_CREATE = 'STARTING_DRAFT_CREATE_IN_TEMPLATE_LIST';
export const GET_SUPPLIER_LOCATIONS_LIST = 'GET_SUPPLIER_LOCATIONS_LIST_IN_TEMPLATE_LIST';
export const POPULATE_CONTRACTS_COUNT = 'POPULATE_CONTRACTS_COUNT_IN_TEPLATE_LIST';
export const UPDATE_LOC_PROPS = 'UPDATE_LOC_PROPS_IN_TEMPLATE_LIST';
export const GOT_ALL_CONTRACT_PERIODS = 'GOT_ALL_CONTRACT_PERIODS_FOR_TEMPLATE_GROUP_WIZARD';
export const UPDATING_TEMPLATE_NAME = 'UPDATING_TEMPLATE_NAME_IN_TEMPLATE_LIST';
export const TEMPLATE_NAME_UPDATED = 'TEMPLATE_NAME_UPDATED_IN_TEMPLATE_LIST';
export const TEMPLATE_NAME_UPDATED_DUPLICATED = 'TEMPLATE_NAME_UPDATED_DUPLICATED_IN_TEMPLATE_LIST';
export const STARTING_TEMPLATE_GROUP_CREATION = 'STARTING_TEMPLATE_GROUP_CREATION_IN_TEMPLATE_LIST';
export const TEMPLATE_GROUP_CREATED = 'TEMPLATE_GROUP_CREATED_IN_TEMPLATE_LIST';
export const TEMPLATE_GROUP_UPDATED = 'TEMPLATE_GROUP_UPDATED_IN_TEMPLATE_LIST';
export const DOWNLOADING_PDF_ZIP = 'DOWNLOADING_PDF_ZIP_IN_TEMPLATE_LIST';
export const PDF_ZIP_DOWNLOADED = 'PDF_ZIP_DOWNLOADED_IN_TEMPLATE_LIST';
export const UPDATE_FILTERS = '{template-list} UPDATE_FILTERS';



// WEBPACK FOOTER //
// ./src/app/stores/contracting/template-list/template-list-constants.js